import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDomainInfo } from '../utils/utils';

function ConnectSkin({ ConnectUser, setShow }) {
    const { userId } = useParams();
    const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
    const storeName = localStorage.getItem('userid');
    const storelogo = localStorage.getItem('storeavater');
    const navigate = useNavigate();
    const [user, setUser] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));

        validateField(name, value);
    };

    const validateField = (fieldName, value) => {
        let errorMessage = "";

        switch (fieldName) {
            case "name":
                if (!value) {
                    errorMessage = "Name is required";
                }
                break;
            case "email":
                if (
                    !value ||
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
                ) {
                    errorMessage = "Invalid email address";
                }
                break;
            case "phone":
                if (!value || !/^\d{10}$/.test(value)) {
                    errorMessage = "Phone number must be 10 digits";
                }
                break;
            default:
                break;
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: errorMessage,
        }));
    };

    const gainLead = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}user/add-gainlead`,
                {
                    parentUser: ConnectUser.id,
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                }
            );

            if (res.status === 200 || res.status === 201) {
                sessionStorage.setItem("token", res.data.token);
                if (ConnectUser.helloService && ConnectUser.helloDirect === true) {
                    window.location.replace(ConnectUser.helloService.content);
                } else {
                    toast.success("Lead captured successfully!");
                    setTimeout(() => {
                        navigate(isPredefinedDomain ? `/${uid}` : "/");
                    }, 2000);
                }

            } else {
                throw new Error("Failed to capture lead");
            }
        } catch (e) {
            console.error(e);
            toast.error("Something went wrong. Please try again.");
        }
    };


    return (
        <div className="connect-wrapper">
            <ToastContainer autoClose={1000} position="top-center" />
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <title />
            <link
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
                rel="stylesheet"
                integrity="sha384-9ndCyUaIbzAi2FUVXJi0CjmCapSmO7SnpJef0486qhLnuZ2cdeRhO02iuK6FUUVM"
                crossOrigin="anonymous"
            />
            <div className="container-fluid bg-white">
                <div className="row" id="hallo-header">
                    <div className="col-md-9 col-9"></div>
                    <div className="col-md-3 col-3">
                        <Link
                            className="button -sm -dark text-white"
                            style={{ transform: "scale(0.75)" }}
                            onClick={() => setShow(false)}
                        >
                            Skip
                        </Link>

                    </div>
                </div>
            </div>
            <div className="container-fluid pt-4 py-3" id="hallo-text">
                <div className="row">
                    <div className="col-md-12 col-12 text-center">
                        <img
                            src={storelogo}
                            width={'50%'}
                            className="mx-auto d-block"
                            alt="..."
                        />
                    </div>
                    <div className="col-md-12 col-12 text-center mt-0">
                        <h2 className="text-center">
                            You are connecting with
                            <br />
                            <span>{storeName || ""} </span>
                        </h2>
                    </div>
                    <div className="col-md-12 col-12 text-center mt-3">
                        <h2 className="text-center">
                            Exchange your contact details to see <br />
                            Hello Profile!
                        </h2>
                    </div>
                </div>
            </div>
            <form method="POST"
                onSubmit={gainLead}
            >
                <div className="container-fluid py-3 mt-1">
                    <div className="row" id="form">
                        <div className="input-group">
                            <input
                                id="nameInput"
                                name="name"
                                onChange={handleInputChange}
                                value={user.name}
                                className="form-control"
                                required
                                placeholder=" "
                            />
                            <label htmlFor="text">Name</label>
                            <span className="input-group-text" id="basic-addon2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    fill="#0d6efd"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="container-fluid py-3">
                    <div className="row" id="form">
                        <div className="input-group">
                            <input
                                id="emailInput"
                                name="email"
                                onChange={handleInputChange}
                                value={user.email}
                                className="form-control"
                                required
                                placeholder=" "
                            />
                            <label htmlFor="text">Email ID</label>
                            <span className="input-group-text" id="basic-addon2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    fill="#0d6efd"
                                    className="bi bi-envelope"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                </svg>
                            </span>
                        </div>
                    </div>
                    {errors.email && (
                        <p style={{ color: "red", marginLeft: "0.5rem" }}>{errors.email}</p>
                    )}
                </div>
                <div className="container-fluid py-3">
                    <div className="row" id="form">
                        <div className="input-group">
                            <input
                                className="form-control"
                                name="phone"
                                onChange={handleInputChange}
                                value={user.phone}
                                id="phoneField"
                                required
                                placeholder=" "
                                onKeyPress={(e) => {
                                    // Allow only numeric input
                                    const validChars = /^[0-9]+$/;
                                    if (!validChars.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <span id="phoneCode">
                                +91 <span style={{ fontSize: "20px" }}>|</span>
                            </span>
                            <label htmlFor="text">Phone Number</label>
                            <span className="input-group-text" id="basic-addon2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    fill="#0d6efd"
                                    className="bi bi-telephone"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                {errors.phone && (
                    <p style={{ color: "red", marginLeft: "1rem" }}>{errors.phone}</p>
                )}
                <div className="container-fluid py-3">
                    <div className="row" id="button">
                        <div className="d-grid gap-2">
                            <input
                                className="btn p-3"
                                id="submitBtn"
                                disabled={user.name && user.email && user.phone ? false : true}
                                name="connect"
                                defaultValue="Connect"
                                type="submit"
                            />
                        </div>
                        <h2 className="text-1">GO PHYGITAL</h2>
                        <p className="text-2">
                            Powered by HelloLeads<sup>TM</sup>
                        </p>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ConnectSkin